function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, e, o, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), e, o); return 2 & r && "function" == typeof p ? function (t) { return p.apply(o, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import * as React from 'react';
import * as randomstring from 'randomstring';
import { BetterSelectItem } from './better-select-item';
import { BetterSelectPortal } from './better-select-portal';
import './better-select.scss';
import { arrayContains, escapeRegExpString } from '../../utils';
var preventBubbling = function preventBubbling(event) {
  // if (event) { event.stopPropagation(); }
};
export var BetterSelect = /*#__PURE__*/function (_React$Component) {
  function BetterSelect(props) {
    var _this;
    _classCallCheck(this, BetterSelect);
    _this = _callSuper(this, BetterSelect, [props]);
    _this.eid = randomstring.generate({
      length: 6
    });
    _this.defaultClassNames = ['better-select', 'bsl-container'];
    _this.ref = void 0;
    _this.dropdownRef = void 0;
    _this.searchFieldRef = void 0;
    _this.unmounting = false;
    _this.muationObserver = void 0;
    _this.defaultPlaceholder = 'Select an option';
    _this.posLoader = void 0;
    _this.state = {
      mode: _this.props.mode || 'single',
      isOpen: false,
      selectedOptions: [],
      rect: {}
    };
    return _this;
  }
  _inherits(BetterSelect, _React$Component);
  return _createClass(BetterSelect, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;
        var W, defaultValue, defaultValueSet, selectedOptions, outputValue;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              W = window;
              W.__swbdd__ = W.__swbdd__ || [];
              W.__swbdd__.push(this);
              this.wireEventHandlers();
              defaultValue = this.props.defaultValue;
              defaultValueSet = false;
              if (!(!!defaultValue && defaultValue.length > 0)) {
                _context.next = 12;
                break;
              }
              selectedOptions = defaultValue;
              if (_typeof(defaultValue[0]) !== 'object') {
                selectedOptions = this.getUnnestedOptions().filter(function (opt) {
                  return _this2.props.defaultValue.indexOf(opt.value) !== -1;
                });
              }
              _context.next = 11;
              return this.setState({
                selectedOptions: selectedOptions
              });
            case 11:
              defaultValueSet = true;
            case 12:
              _context.next = 14;
              return this.readValueFromProps();
            case 14:
              if (defaultValueSet) {
                outputValue = this.state.selectedOptions.map(function (opt) {
                  return opt.value;
                });
                if (this.props.mode !== 'multiple') {
                  if (this.state.selectedOptions.length > 0) {
                    outputValue = this.state.selectedOptions[0].value;
                  }
                }
                if (!!this.props.onChange) {
                  this.props.onChange(outputValue);
                } else {
                  if (!!this.props.onClose) {
                    this.props.onClose(outputValue);
                  }
                }
              }
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unmounting = true;
      this.unwireEventHandlers();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.readValueFromProps();
    }
  }, {
    key: "readValueFromProps",
    value: function () {
      var _readValueFromProps = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var hasOptions, value, optionValues, validValues, propsValue, currentSelectionValues, stateValueSig, propsValueSig, selectedOptions;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              hasOptions = Array.isArray(this.props.options) && this.props.options.length > 0;
              if (!(hasOptions && this.props.value)) {
                _context2.next = 14;
                break;
              }
              value = this.state.mode === 'single' ? Array.isArray(this.props.value) ? this.props.value : [this.props.value] : this.props.value;
              optionValues = this.getUnnestedOptions().map(function (opt) {
                return opt.value;
              });
              validValues = value.every(function (v) {
                return arrayContains(optionValues, v);
              });
              if (!validValues) {
                _context2.next = 14;
                break;
              }
              propsValue = value.filter(function (v) {
                return v !== undefined && v !== null;
              });
              currentSelectionValues = this.state.selectedOptions.map(function (opt) {
                return opt.value;
              });
              stateValueSig = btoa(unescape(encodeURIComponent(JSON.stringify(currentSelectionValues.sort()))));
              propsValueSig = btoa(unescape(encodeURIComponent(JSON.stringify(propsValue.sort()))));
              if (!(stateValueSig !== propsValueSig)) {
                _context2.next = 14;
                break;
              }
              selectedOptions = this.getUnnestedOptions().filter(function (opt) {
                return propsValue.indexOf(opt.value) !== -1;
              });
              _context2.next = 14;
              return this.setState({
                selectedOptions: selectedOptions
              });
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function readValueFromProps() {
        return _readValueFromProps.apply(this, arguments);
      }
      return readValueFromProps;
    }()
  }, {
    key: "setState",
    value: function () {
      var _setState = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(state, callback) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this.unmounting) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", _superPropGet(BetterSelect, "setState", this, 3)([state, callback]));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function setState(_x, _x2) {
        return _setState.apply(this, arguments);
      }
      return setState;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var state = this.state;
      var props = this.props;
      var handleOpenStateChange = this.handleOpenStateChange.bind(this);
      var handleOptionSearch = this.handleOptionSearch.bind(this);
      var handleSelectAllChange = this.handleSelectAllChange.bind(this);
      var allOptions = this.getUnnestedOptions();
      var visibleOptions = state.filteredOptions || this.buildFilteredOptionsArray(props.options);
      var selectedItemCount = state.selectedOptions.length;
      var allItemsSelected = selectedItemCount > 0 && state.selectedOptions.length === allOptions.length;
      var disableSelectAll = this.isMultiMode() ? props.disableSelectAll : true;
      var dropdownClassNames = ['bsl-dropdown'];
      if (selectedItemCount === 0) {
        dropdownClassNames.push('no-selections');
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        ref: function ref(element) {
          return _this3.ref = element;
        },
        id: this.eid,
        className: this.buildClassNames()
      }, /*#__PURE__*/React.createElement("div", {
        className: dropdownClassNames.join(' ')
      }, /*#__PURE__*/React.createElement("div", {
        className: "bsl-dropdown-heading",
        onClick: handleOpenStateChange
      }, /*#__PURE__*/React.createElement("span", {
        className: "bsl-dropdown-title"
      }, this.buildTitle()), /*#__PURE__*/React.createElement("span", {
        className: "bsl-dropdown-loading-indicator".concat(props.loading ? ' bsl-loading' : '')
      }), /*#__PURE__*/React.createElement("span", {
        className: "bsl-dropdown-arrow ".concat(state.isOpen ? 'bsl-open' : 'bsl-closed')
      })))), /*#__PURE__*/React.createElement(BetterSelectPortal, {
        portalId: "bsl-dropdown-container-".concat(this.eid),
        className: this.buildPortalClassNames(),
        container: props.dropdownContainer || document.body
      }, this.state.isOpen && /*#__PURE__*/React.createElement("div", {
        ref: function ref(el) {
          return _this3.dropdownRef = el;
        },
        className: "bsl-dropdown-contents-wrapper",
        style: {
          width: state.rect.width,
          top: (state.rect.y || state.rect.top) + state.rect.height + 2,
          left: state.rect.x || state.rect.left
        }
      }, !props.disableSearch && /*#__PURE__*/React.createElement("div", {
        className: "bsl-dropdown-search"
      }, /*#__PURE__*/React.createElement("input", {
        ref: function ref(el) {
          return _this3.searchFieldRef = el;
        },
        type: "text",
        onKeyUp: function onKeyUp(ev) {
          return handleOptionSearch(ev);
        },
        placeholder: props.searchPlaceholder || 'Search'
      })), /*#__PURE__*/React.createElement("div", {
        className: "bsl-dropdown-option-list"
      }, !state.filteredOptions && !disableSelectAll && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "bsl-dropdown-option bsl-select-all".concat(allItemsSelected ? ' bsl-selected' : ''),
        onClick: handleSelectAllChange
      }, /*#__PURE__*/React.createElement("span", {
        className: "bsl-dropdown-option-label"
      }, this.props.selectAllLabel || 'Select All'), /*#__PURE__*/React.createElement("span", {
        className: "bsl-dropdown-option-toggle"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        checked: true,
        readOnly: true,
        tabIndex: -1
      }))), /*#__PURE__*/React.createElement("div", {
        className: "bsl-dropdown-divider"
      })), visibleOptions.length > 0 ? visibleOptions.map(function (option) {
        return _this3.renderOptionItem(option);
      }) : /*#__PURE__*/React.createElement("span", {
        className: "bsl-dropdown-empty"
      }, props.emptyOptionsPlaceholder || 'No options found')))));
    }
  }, {
    key: "close",
    value: function close() {
      var updateState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var isSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this.state.isOpen || isSelf) {
        if (updateState) {
          this.setState({
            isOpen: false,
            filteredOptions: undefined,
            showDropdownBelow: undefined
          });
        }
        if (!!this.props.onClose) {
          var values = this.state.selectedOptions.map(function (opt) {
            return opt.value;
          });
          this.props.onClose(this.isMultiMode() ? values : values[0]);
        }
      }
    }
  }, {
    key: "getUnnestedOptions",
    value: function getUnnestedOptions() {
      var withGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (withGroups) return this.props.options;
      var opts = this.props.options.map(function (opt) {
        if (opt.options) {
          return opt.options;
        }
        return opt;
      });
      var flatOpts = opts.reduce(function (arr, val) {
        return arr.concat(val);
      }, []);
      return flatOpts;
    }
  }, {
    key: "wireEventHandlers",
    value: function wireEventHandlers() {
      var _this4 = this;
      document.addEventListener('mousedown', this.handleDocumentClick.bind(this));
      if (this.props.closeOnEscape) {
        document.addEventListener('keyup', this.handleDocumentKeyUp.bind(this));
      }
      this.ref.addEventListener('mousedown', preventBubbling);
      this.muationObserver = new MutationObserver(function () {
        _this4.setState(function () {
          return {
            rect: _this4.ref.getBoundingClientRect()
          };
        });
      });
      this.muationObserver.observe(this.ref, {
        childList: true,
        subtree: true
      });
    }
  }, {
    key: "unwireEventHandlers",
    value: function unwireEventHandlers() {
      document.removeEventListener('mousedown', this.handleDocumentClick.bind(this));
      if (this.props.closeOnEscape) {
        document.removeEventListener('keyup', this.handleDocumentKeyUp.bind(this));
      }
      this.ref.removeEventListener('mousedown', preventBubbling);
      this.muationObserver.disconnect();
    }
  }, {
    key: "buildTitle",
    value: function buildTitle() {
      var _this5 = this;
      var selectAllLabel = (this.props.selectAllLabel || '').trim();
      var hasSelectAllLabel = !!selectAllLabel && selectAllLabel.length > 0;
      var totalSelected = this.state.selectedOptions.length;
      var allItemsSelected = totalSelected === this.getUnnestedOptions().length;
      var maxDisplayCount = this.props.maxDisplayCount || 0;
      var maxDisplayMet = maxDisplayCount > 0 && totalSelected > maxDisplayCount;
      var prefix;
      if (!!this.props.prefix && !!this.props.prefix.trim()) {
        prefix = "".concat(this.props.prefix.trim(), ": ");
      }
      var title = /*#__PURE__*/React.createElement("span", {
        className: "bsl-dropdown-placeholder"
      }, this.props.placeholder || this.defaultPlaceholder);
      if (this.state.selectedOptions.length > 0) {
        if (allItemsSelected && hasSelectAllLabel) {
          title = /*#__PURE__*/React.createElement("span", {
            className: "bsl-dropdown-selections"
          }, /*#__PURE__*/React.createElement("span", {
            className: "bsl-dropdown-selection"
          }, this.props.selectAllLabel));
        } else {
          if (maxDisplayMet) {
            title = this.handleMaxDisplayMet();
          } else {
            var selectedValues = this.state.selectedOptions.map(function (opt) {
              return opt.value;
            });
            var orderedSelections = this.getUnnestedOptions().filter(function (opt) {
              return selectedValues.indexOf(opt.value) !== -1;
            });
            title = /*#__PURE__*/React.createElement("span", {
              className: "bsl-dropdown-selections"
            }, orderedSelections.map(function (option, index) {
              return _this5.renderSelectedItem(option, index, _this5.state.selectedOptions);
            }));
          }
        }
      }
      if (this.props.disabled && !!this.props.disabledValue) {
        title = /*#__PURE__*/React.createElement("span", {
          className: "bsl-dropdown-prefix"
        }, this.props.disabledValue);
      }
      if (this.state.showInvalidMessage) {
        title = this.props.invalidValueMessage || 'Invalid Selection';
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "bsl-dropdown-prefix"
      }, prefix), title);
    }
  }, {
    key: "renderSelectedItem",
    value: function renderSelectedItem(option, index, options) {
      var _this6 = this;
      if (this.props.renderSelectedItem) {
        return this.props.renderSelectedItem(option, index, options);
      }
      var isLastItem = index + 1 === options.length;
      var display = /*#__PURE__*/React.createElement("span", {
        key: option.value,
        className: "bsl-dropdown-selection"
      }, !!option.renderSelectedItem ? option.renderSelectedItem() : option.label || option.value, !isLastItem ? ', ' : '');
      if (!!this.props.theme) {
        if (this.props.theme === 'tags') {
          display = /*#__PURE__*/React.createElement("span", {
            key: option.value,
            className: "bsl-dropdown-selection bsl-tag",
            onClick: function onClick(ev) {
              return _this6.handleTagClick(ev, option);
            }
          }, !!option.renderSelectedItem ? option.renderSelectedItem() : option.label || option.value);
        }
      }
      return display;
    }
  }, {
    key: "renderOptionItem",
    value: function renderOptionItem(option) {
      var _this7 = this;
      if ('options' in option) {
        return /*#__PURE__*/React.createElement("div", {
          key: option.label,
          className: "bsl-dropdown-option-group"
        }, /*#__PURE__*/React.createElement("div", {
          className: "bsl-dropdown-option-group-label"
        }, option.label), option.options.map(function (o) {
          return _this7.renderOptionItem(o);
        }));
      }
      var currentSelectedValues = this.state.selectedOptions.map(function (opt) {
        return opt.value;
      });
      var itemIsSelected = currentSelectedValues.indexOf(option.value) !== -1;
      var handleItemChange = this.handleItemChange.bind(this);
      return /*#__PURE__*/React.createElement(BetterSelectItem, {
        key: option.value,
        value: option.value,
        label: option.label,
        checked: itemIsSelected,
        onChange: handleItemChange,
        renderOptionItem: this.props.renderOptionItem,
        disabled: option.disabled
      });
    }
  }, {
    key: "handleTagClick",
    value: function () {
      var _handleTagClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(ev, option) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (ev) {
                ev.preventDefault();
                ev.stopPropagation();
              }
              if (!this.props.disabled) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return");
            case 3:
              return _context4.abrupt("return", this.setState(function (_ref) {
                var selectedOptions = _ref.selectedOptions;
                selectedOptions = selectedOptions.filter(function (o) {
                  return o.value !== option.value;
                });
                return {
                  selectedOptions: selectedOptions
                };
              }));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleTagClick(_x3, _x4) {
        return _handleTagClick.apply(this, arguments);
      }
      return handleTagClick;
    }()
  }, {
    key: "handleMaxDisplayMet",
    value: function handleMaxDisplayMet() {
      var selectedOptions = this.state.selectedOptions;
      if (this.props.maxDisplayFormatter) {
        return this.props.maxDisplayFormatter(selectedOptions);
      }
      var multi = selectedOptions.length > 1;
      return "".concat(selectedOptions.length, " ").concat(multi ? 'Items' : 'Item', " Selected");
    }
  }, {
    key: "handleSelectAllChange",
    value: function handleSelectAllChange() {
      var _this8 = this;
      var allItemsSelected = this.state.selectedOptions.length === this.getUnnestedOptions().length;
      var selectedOptions = [];
      if (!allItemsSelected) {
        selectedOptions = this.getUnnestedOptions();
      }
      this.setState(function () {
        return {
          selectedOptions: selectedOptions
        };
      }, function () {
        if (_this8.props.onChange) {
          var values = selectedOptions.map(function (opt) {
            return opt.value;
          });
          _this8.props.onChange(values);
        }
      });
    }
  }, {
    key: "handleItemChange",
    value: function handleItemChange(option, checked) {
      var _this9 = this;
      this.setState(function (_ref2) {
        var selectedOptions = _ref2.selectedOptions,
          isOpen = _ref2.isOpen;
        if (_this9.isMultiMode()) {
          var optionIndex = selectedOptions.findIndex(function (opt) {
            return opt.value === option.value;
          });
          if (checked) {
            if (optionIndex === -1) {
              selectedOptions.push(option);
            }
          } else {
            if (optionIndex !== -1) {
              selectedOptions.splice(optionIndex, 1);
            }
          }
          return {
            isOpen: isOpen,
            selectedOptions: selectedOptions
          };
        }
        return {
          isOpen: !isOpen,
          selectedOptions: [option]
        };
      }, function () {
        if (_this9.props.onChange) {
          var opts = _this9.state.selectedOptions;
          var values = opts.map(function (opt) {
            return opt.value;
          });
          _this9.props.onChange(_this9.isMultiMode() ? values : values[0], _this9.isMultiMode() ? opts : opts[0]);
        }
      });
    }
  }, {
    key: "handleOpenStateChange",
    value: function () {
      var _handleOpenStateChange = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(ev) {
        var _this10 = this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if ('preventDefault' in ev) {
                ev.preventDefault();
                ev.stopPropagation();
                if ('nativeEvent' in ev) {
                  ev.nativeEvent.preventDefault();
                  ev.nativeEvent.stopPropagation();
                }
              }
              if (!this.props.disabled) {
                _context5.next = 3;
                break;
              }
              return _context5.abrupt("return");
            case 3:
              _context5.next = 5;
              return this.setState(function (_ref3) {
                var isOpen = _ref3.isOpen,
                  filteredOptions = _ref3.filteredOptions,
                  showDropdownBelow = _ref3.showDropdownBelow;
                return {
                  isOpen: !isOpen,
                  filteredOptions: isOpen ? undefined : filteredOptions,
                  showDropdownBelow: !isOpen ? undefined : showDropdownBelow,
                  rect: _this10.ref.getBoundingClientRect()
                };
              });
            case 5:
              if (this.state.isOpen) {
                this.closeOtherDropdowns();
                if (!this.props.disableSearch) {
                  setTimeout(function () {
                    return _this10.searchFieldRef.focus();
                  }, 50);
                }
              } else {
                this.close(false, true);
              }
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handleOpenStateChange(_x5) {
        return _handleOpenStateChange.apply(this, arguments);
      }
      return handleOpenStateChange;
    }()
  }, {
    key: "closeOtherDropdowns",
    value: function closeOtherDropdowns() {
      var _this11 = this;
      var W = window;
      if (!!W.__swbdd__) {
        W.__swbdd__.filter(function (dd) {
          return dd.eid !== _this11.eid;
        }).forEach(function (dd) {
          return dd.close();
        });
      }
    }
  }, {
    key: "buildClassNames",
    value: function buildClassNames() {
      var classNames = _toConsumableArray(this.defaultClassNames);
      if (this.props.loading === true) {
        classNames.push('bsl-loading');
      }
      classNames.push(this.state.isOpen ? 'bsl-open' : 'bsl-closed');
      var size = this.props.size || 'default';
      classNames.push("bsl-size-".concat(size.toLowerCase()));
      if (!!this.props.theme) {
        classNames.push("theme-".concat(this.props.theme));
      }
      if (!!this.props.skeletonMode) {
        classNames.push('skeleton');
      }
      if (this.props.className && this.props.className.trim() !== '') {
        classNames.push(this.props.className.trim());
      }
      if (this.props.disabled) {
        classNames.push('bsl-disabled');
      }
      return classNames.join(' ');
    }
  }, {
    key: "buildPortalClassNames",
    value: function buildPortalClassNames() {
      var _this12 = this;
      var classNames = [];
      if (this.props.loading === true) {
        classNames.push('bsl-loading');
      }
      var size = this.props.size || 'default';
      classNames.push("bsl-size-".concat(size.toLowerCase()));
      if (!!this.props.theme) {
        classNames.push("theme-".concat(this.props.theme));
      }
      if (!!this.props.dropdownClassName) {
        classNames.push(this.props.dropdownClassName);
      }
      if (this.props.disabled) {
        classNames.push('bsl-disabled');
      }
      var docRect = document.body.getBoundingClientRect();
      if (this.state.showDropdownBelow === undefined) {
        classNames.push('pos-loading');
      } else if (!this.state.showDropdownBelow) {
        classNames.push('pos-above');
      }
      if (!this.props.loading && this.state.showDropdownBelow === undefined) {
        if (!!this.posLoader) clearTimeout(this.posLoader);
        this.posLoader = setTimeout(function () {
          if (!!_this12.dropdownRef) {
            var ddRect = _this12.dropdownRef.getBoundingClientRect();
            var ddBottomDiff = docRect.bottom - ddRect.bottom;
            var ddShowBelow = ddBottomDiff > 5;
            if (ddShowBelow) {
              if (_this12.state.showDropdownBelow !== true) {
                _this12.setState({
                  showDropdownBelow: true
                });
              }
            } else {
              if (_this12.state.showDropdownBelow !== false) {
                _this12.setState({
                  showDropdownBelow: false
                });
              }
            }
          }
        }, 50);
      }
      return classNames.join(' ');
    }
  }, {
    key: "buildFilteredOptionsArray",
    value: function buildFilteredOptionsArray(options) {
      var _this13 = this;
      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        return true;
      };
      var seed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      options.forEach(function (opt) {
        if ('options' in opt) {
          var group = {
            label: opt.label,
            value: opt.label,
            disabled: opt.disabled,
            options: _this13.buildFilteredOptionsArray(opt.options, filter)
          };
          if (group.options.length > 0) {
            seed.push(group);
          }
        } else {
          if (filter(opt)) {
            seed.push(opt);
          }
        }
      });
      return seed;
    }
  }, {
    key: "handleOptionSearch",
    value: function handleOptionSearch(event) {
      var target = event.target;
      var searchValue = !!target.value ? target.value.trim() : undefined;
      var allOptions = this.props.options;
      var filteredOptions;
      if (searchValue && searchValue.length > 0) {
        var searchRgx = new RegExp(escapeRegExpString(searchValue), 'i');
        filteredOptions = this.buildFilteredOptionsArray(allOptions, function (opt) {
          var value = opt.value || '';
          var label = opt.label || value;
          return searchRgx.test(label.toString()) || searchRgx.test(value.toString());
        });
      }
      this.setState(function () {
        return {
          filteredOptions: filteredOptions
        };
      });
    }
  }, {
    key: "handleDocumentKeyUp",
    value: function handleDocumentKeyUp(event) {
      if (this.state.isOpen) {
        if (event.key && event.key.toUpperCase() === 'ESCAPE') {
          preventBubbling(event);
          this.close();
        }
      }
    }
  }, {
    key: "handleDocumentClick",
    value: function handleDocumentClick(event) {
      if (this.state.isOpen) {
        var shouldExecute = true;
        if (!!event.target) {
          var target = event.target;
          if ('classList' in target) {
            if (/bsl-/i.test(target.classList.toString())) {
              shouldExecute = false;
            }
          }
        }
        if (shouldExecute) {
          this.close();
        }
      }
    }
  }, {
    key: "isMultiMode",
    value: function isMultiMode() {
      return this.state.mode === 'multiple';
    }
  }]);
}(React.Component);